export const NODE_DEFAULT_PORTS = {
    ngfw: [{ name: 'port0', ips: 1 }],
    swg: [{ name: 'port0', ips: 1 }],
    collector: [{ name: 'port0', ips: 1 }],
    dcfw: [{ name: 'port0', ips: 1 }],
    mc: [{ name: 'port0', ips: 1 }],
    waf: [{ name: 'port0', ips: 1 }],
    siem: [{ name: 'port0', ips: 1 }],
    logan: [{ name: 'port0', ips: 1 }],
    ubuntu: [{ name: 'port0', ips: 1 }],
    mikrotik: [{ name: 'port0', ips: 1 }],
    cli_a_lx: [{ name: 'port0', ips: 1 }],
    mgt_a: [{ name: 'port0', ips: 1 }],
    mgt_a_intro: [{ name: 'port0', ips: 1 }],
    testagent: [{ name: 'port0', ips: 1 }],
    ptmgmt: [{ name: 'port0', ips: 1 }],
    ptngfw: [{ name: 'port0', ips: 1 }],
    astralinux: [{ name: 'port0', ips: 1 }],
    redos: [{ name: 'port0', ips: 1 }],
    kalilinux: [{ name: 'port0', ips: 1 }],
    cisco: [{ name: 'port0', ips: 1 }],
    trex: [{ name: 'port0', ips: 1 }],
    ad: [{ name: 'port0', ips: 1 }],
    tech_tour_ad: [{ name: 'port0', ips: 1 }],
    wec: [{ name: 'port0', ips: 1 }],
    isp1: [{ name: 'port0', ips: 1 }],
    isp2: [{ name: 'port0', ips: 1 }],
    isp_intro: [{ name: 'port0', ips: 1 }],
    lan: [{ name: 'port0' }],
    wan: [{ name: 'port0' }],
    dmz: [{ name: 'port0' }],
    mgmt: [{ name: 'port0' }],
    cluster: [{ name: 'port0' }],
    vrrp: [{ name: 'port0' }, { name: 'port1', ips: 1 }],
    pppoeserver: [
        { name: 'port0', ips: 1 },
        { name: 'port1', ips: 1 },
    ],
    radius: [
        { name: 'port0', ips: 1 },
        { name: 'port1', ips: 1 },
    ],
    webserver: [{ name: 'port0', ips: 1 }],
    www: [{ name: 'port0', ips: 1 }],
    www1: [{ name: 'port0', ips: 1 }],
    www2: [{ name: 'port0', ips: 1 }],
    vulnerableapp: [{ name: 'port0', ips: 1 }],
    internet: [{ name: 'port0', ips: 1 }],

    windows: [{ name: 'port0', ips: 1 }],
    encryptor: [{ name: 'port0', ips: 1 }],
    ftp: [{ name: 'port0', ips: 1 }],
    telemetryservice: [
        { name: 'port0', ips: 1 },
        { name: 'port1', ips: 1 },
    ],
    smtp: [
        { name: 'port0', ips: 1 },
        { name: 'port1', ips: 1 },
    ],
    icap: [
        { name: 'port0', ips: 1 },
        { name: 'port1', ips: 1 },
    ],
    tacacs: [
        { name: 'port0', ips: 1 },
        { name: 'port1', ips: 1 },
    ],
};
export const INITIAL_PCAP_FILE_CPS = 1000;
export const INITIAL_TREX_CONFIG = {
    client_ip_range: {
        from: '1.1.1.1',
        to: '1.1.1.255',
    },
    server_ip_range: {
        from: '49.1.1.1',
        to: '49.1.1.255',
    },
    multiplicator: 1,
    dual_port_mask: '1.0.0.0',
    pcap_files: [],
};
export const NODE_DEFAULT_PARAMS = {
    ngfw: {
        memory: 16,
        cpu: 4,
    },
    collector: {
        memory: 16,
        cpu: 4,
    },
    dcfw: {
        memory: 16,
        cpu: 8,
    },
    mc: {
        memory: 16,
        cpu: 4,
    },
    waf: {
        memory: 16,
        cpu: 4,
    },
    siem: {
        memory: 16,
        cpu: 4,
        role: 'regular',
    },
    logan: {
        memory: 16,
        cpu: 4,
        role: 'regular',
    },
    swg: {
        memory: 16,
        cpu: 4,
    },
    ubuntu: {
        version: '22.04',
        memory: 8,
        cpu: 2,
    },
    mikrotik: {
        memory: 8,
        cpu: 2,
    },
    cli_a_lx: {
        version: '22.04',
        memory: 8,
        cpu: 2,
    },
    mgt_a: {
        version: '22.04',
        memory: 8,
        cpu: 2,
    },
    mgt_a_intro: {
        version: '22.04',
        memory: 8,
        cpu: 2,
    },
    testagent: {
        version: '22.04',
        memory: 8,
        cpu: 2,
    },
    ptmgmt: {
        memory: 8,
        cpu: 2,
    },
    ptngfw: {
        memory: 8,
        cpu: 2,
    },
    cisco: {
        memory: 8,
        cpu: 2,
        configName: '',
        config: '',
    },
    trex: {
        memory: 8,
        cpu: 4,
        trexConfig: INITIAL_TREX_CONFIG,
    },
    webserver: {
        memory: 8,
        cpu: 2,
        words: [],
    },
    www: {
        memory: 8,
        cpu: 2,
        words: [],
    },
    www1: {
        memory: 8,
        cpu: 2,
        words: [],
    },
    www2: {
        memory: 8,
        cpu: 2,
        words: [],
    },
    vulnerableapp: {
        memory: 8,
        cpu: 2,
    },
    internet: {
        memory: 8,
        cpu: 2,
    },
    astralinux: {
        memory: 8,
        cpu: 2,
    },
    redos: {
        memory: 8,
        cpu: 2,
    },
    kalilinux: {
        memory: 8,
        cpu: 2,
    },
    windows: {
        memory: 8,
        cpu: 2,
        version: 10,
        configName: '',
        config: '',
    },
    encryptor: {
        memory: 8,
        cpu: 2,
        configName: '',
        config: '',
    },
    pppoeserver: {
        'ips-pool-size': 1,
        'auth-type': 'chap',
    },
    radius: {
        'users-pool-size': 1,
    },
    ad: {
        memory: 8,
        cpu: 2,
        user_count: 1,
        group_count: 1,
        version: '2019',
        configName: '',
        config: '',
    },
    tech_tour_ad: {
        memory: 8,
        cpu: 2,
        user_count: 1,
        group_count: 1,
        version: '2019',
        configName: '',
        config: '',
    },
    wec: {
        memory: 8,
        cpu: 2,
    },
    isp1: {
        memory: 8,
        cpu: 2,
        user_count: 1,
        version: '2019',
    },
    isp2: {
        memory: 8,
        cpu: 2,
        user_count: 1,
        version: '2019',
    },
    isp_intro: {
        memory: 8,
        cpu: 2,
        user_count: 1,
        version: '2019',
    },
    ftp: {
        memory: 8,
        cpu: 2,
    },
    telemetryservice: {
        memory: 8,
        cpu: 2,
    },
    smtp: {
        memory: 8,
        cpu: 2,
    },
    icap: {
        memory: 8,
        cpu: 2,
        serversCount: 1,
    },
    tacacs: {
        'users-pool-size': 1,
    },
};
export const NODE_PARAMS_INTERVAL = {
    ngfw: {
        memory: [6, 64],
        cpu: [2, 16],
    },
    collector: {
        memory: [6, 64],
        cpu: [2, 16],
    },
    dcfw: {
        memory: [6, 64],
        cpu: [2, 32],
    },
    mc: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    logan: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    waf: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    siem: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    swg: {
        memory: [6, 64],
        cpu: [2, 16],
    },
    ubuntu: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    mikrotik: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    cli_a_lx: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    mgt_a: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    mgt_a_intro: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    testagent: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    ptmgmt: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    ptngfw: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    cisco: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    trex: {
        memory: [4, 64],
        cpu: [4, 16],
    },
    webserver: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    www: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    www1: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    www2: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    vulnerableapp: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    internet: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    astralinux: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    redos: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    kalilinux: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    windows: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    encryptor: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    pppoeserver: {
        'ips-pool-size': [1, 100],
    },
    radius: {
        'users-pool-size': [0, 100],
    },
    ad: {
        memory: [4, 64],
        cpu: [2, 16],
        user_count: [0, 100],
        group_count: [0, 100],
    },
    tech_tour_ad: {
        memory: [4, 64],
        cpu: [2, 16],
        user_count: [0, 100],
        group_count: [0, 100],
    },
    wec: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    isp1: {
        memory: [4, 64],
        cpu: [2, 16],
        user_count: [0, 100],
    },
    isp_intro: {
        memory: [4, 64],
        cpu: [2, 16],
        user_count: [0, 100],
    },
    isp2: {
        memory: [4, 64],
        cpu: [2, 16],
        user_count: [0, 100],
    },
    ftp: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    telemetryservice: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    smtp: {
        memory: [4, 64],
        cpu: [2, 16],
    },
    icap: {
        memory: [4, 64],
        cpu: [2, 16],
        serversCount: [0, 100],
    },
    tacacs: {
        'users-pool-size': [1, 100],
    },
};
export const NODE_SIZES = {
    ad: { width: 60, height: 80 },
    tech_tour_ad: { width: 60, height: 80 },
    wec: { width: 80, height: 80 },
    isp1: { width: 80, height: 80 },
    isp_intro: { width: 80, height: 80 },
    isp2: { width: 80, height: 80 },
    ubuntu: { width: 80, height: 80 },
    mikrotik: { width: 80, height: 80 },
    cli_a_lx: { width: 80, height: 80 },
    mgt_a: { width: 80, height: 80 },
    mgt_a_intro: { width: 80, height: 80 },
    testagent: { width: 80, height: 80 },
    ptmgmt: { width: 80, height: 80 },
    ptngfw: { width: 80, height: 80 },
    cisco: { width: 80, height: 60 },
    trex: { width: 80, height: 80 },
    astralinux: { width: 80, height: 80 },
    redos: { width: 80, height: 80 },
    kalilinux: { width: 80, height: 80 },
    mc: { width: 70, height: 80 },
    ngfw: { width: 70, height: 80 },
    collector: { width: 70, height: 80 },
    swg: { width: 70, height: 80 },
    dcfw: { width: 70, height: 80 },
    logan: { width: 70, height: 80 },
    waf: { width: 70, height: 80 },
    siem: { width: 70, height: 80 },
    vrrp: { width: 100, height: 100 },
    zone: { width: 100, height: 100 },
    pppoeserver: { width: 80, height: 80 },
    radius: { width: 80, height: 80 },
    webserver: { width: 80, height: 80 },
    www: { width: 80, height: 80 },
    www1: { width: 80, height: 80 },
    www2: { width: 80, height: 80 },
    vulnerableapp: { width: 80, height: 80 },
    internet: { width: 80, height: 80 },

    windows: { width: 80, height: 80 },
    encryptor: { width: 80, height: 80 },
    ftp: { width: 80, height: 80 },
    telemetryservice: { width: 80, height: 80 },
    smtp: { width: 80, height: 80 },
    icap: { width: 80, height: 80 },
    tacacs: { width: 80, height: 80 },
};
export const ZONES_LIST = ['lan', 'wan', 'dmz', 'mgmt', 'cluster'];
export const EXTENDED_ZONES_LIST = [...ZONES_LIST];
export const OTHER_NODES_LIST = [
    'ubuntu',
    'astralinux',
    'kalilinux',
    'redos',
    'windows',
    'encryptor',
    'testagent',
    'vrrp',
    'pppoeserver',
    'ad',
    'tech_tour_ad',
    'wec',
    'telemetryservice',
    'smtp',
    'icap',
    'radius',
    'webserver',
    'vulnerableapp',
    'tacacs',
    'cisco',
    'trex',
    'ftp',
    'mikrotik',
    'ptmgmt',
    'ptngfw',
];
export const LABELS_OTHER_NODES_LIST = {
    ubuntu: 'UBUNTU',
    mikrotik: 'MIKROTIK',
    redos: 'RED OS',
    astralinux: 'ASTRA LINUX',
    kalilinux: 'KALI LINUX',
    vrrp: 'VRRP',
    pppoeserver: 'PPPoE-Server',
    windows: 'WINDOWS',
    encryptor: 'ENCRYPTOR',
    ad: 'AD',
    tech_tour_ad: 'TechTourAD',
    wec: 'WEC',
    telemetryservice: 'Telemetry',
    smtp: 'Smtp(s)',
    icap: 'ICAP',
    tacacs: 'TACACS+',
    radius: 'Radius',
    webserver: 'Web-Server',
    vulnerableapp: 'Vulnerable App',
    cisco: 'CISCO',
    trex: 'TREX',
    ftp: 'FTP',
    testagent: 'Test Agent',
    ptmgmt: 'TP MGMT',
    ptngfw: 'TP NGFW',
};
export const ACADEMY_NODES_LIST = [
    'www',
    'www1',
    'www2',
    'isp1',
    'isp2',
    'isp_intro',
    'cli_a_lx',
    'mgt_a',
    'mgt_a_intro',
    'internet',
];
export const LABELS_ACADEMY_NODES_LIST = {
    www: 'WWW',
    www1: 'WWW1',
    www2: 'WWW2',
    isp1: 'ISP1',
    isp2: 'ISP2',
    isp_intro: 'ISP INTRO',
    cli_a_lx: 'CLI-A-LX',
    mgt_a: 'MGT-A',
    mgt_a_intro: 'MGT-A INTRO',
    internet: 'INTERNET',
};
export const UG_NODES_LIST = ['ngfw', 'mc', 'logan', 'waf', 'dcfw', 'siem', 'swg', 'collector'];
export const HANDLE_MOVE_STEP = 10; // reactflow one cell size
export const ALLOWED_ARCHITECTURES_FOR_VIRTUAL_DEPLOY = ['x86'];
export const MAP_ARCHITECTURE_TO_HW_DEVICES = {
    x86: ['c100', 'd200', 'd500', 'e1000', 'f8000', 'e3000'],
    arm: ['c150', 'd250', 'fg', 'x10'],
};
export const PPPOE_BASED_NODES_LIST = ['pppoeserver', 'radius', 'tacacs'];
export const LOGAN_BASED_NODES_LIST = ['logan', 'siem'];
export const STANDS_FILTERS_TYPES = ['deployed', 'no_active'];
export const SCHEME_NAME_MIN_LENGTH = 3;
export const SCHEME_NAME_MAX_LENGTH = 100;
export const IGNORE_NODE_FIELDS = ['positionAbsolute', 'dragging', 'selected'];
